import { observable } from 'mobx';

// Mudar aqui para desenvolvimento
// caso não esteja usando a porta 80 no docker, alterar na prop Appstate.serverAddr abaixo
const isDevMode = process.env.NODE_ENV === 'development';

const AppState = observable({
  token: '',
  userInfo: null,
  empresa: '',
  idPerfil: null,
  isMaster: false,
  isAdmin: false,
  isLoggedIn: false,
  isLoading: false,
  // Em desenvolvimento, cada maquina aponta o proprio backend por REACT_APP_SERVER_ADDR
  // (arquivo frontend/.env.local, fora do git). Sem a variavel, mantem o valor de antes.
  serverAddr: isDevMode
    ? (process.env.REACT_APP_SERVER_ADDR || 'http://localhost:8080')
    : `${process.env.PUBLIC_URL}/server`,
  isDevMode,
});

export default AppState;

/**** Procedimentos para produção **** /
 1) Verificar se serverAddr: 'server',  nesse arquivo
 2) Verificar se "homepage": "/seggest", em package.json
 /************************************/

/**** Procedimentos para teste **** /
 1) Verificar se serverAddr: 'server',  nesse arquivo
 2) Verificar se "homepage": "/teste/seggest", em package.json
 /************************************/
